/*** WARNING: Lots of Math ***/
(function () {

    // 'use strict';

    var canvas = document.getElementById('scratch-canvas');
    if (!canvas) return;

    var hour = 0; // Set time of day to switch code (ie. 4pm = 16).

    var isDrawing, lastPoint, drawOverride;
    var container = document.getElementById('scratch-container'),
        canvasWidth = canvas.width,
        initialWidth = canvas.width,
        canvasHeight = $('.scratcher__content').outerHeight() + 5,
        ctx = canvas.getContext('2d'),
        image = new Image(),
        brush = new Image(),
        firstRun = true,
        autoClear = false;

    //console.log(getUrlParameter('fakeDate'));

    var fakeDate = getUrlParameter('fakeDate');

    var today = new Date();

    if (fakeDate) {
        var t = [];

        fakeDate = fakeDate.replace(/ ?(\d{1,2})\:(\d{1,2})(?:\:(\d{1,2}))?/, function (match, h, m, s) {
            if (h) {
                t.push(h);
                t.push(m);
                if (s) {
                    t.push(s);
                }
            }
            return '';
        });

        if (/^\w{3,} \d{1,2}$/.test(fakeDate)) fakeDate += ' ' + today.getFullYear();

        if (fakeDate) today = new Date(fakeDate);

        if (t.length) today.setHours.apply(today, t);
    }

    //console.log('Today:', today);

    // var today = new Date('oct 12 2016');

    var debugbuddy = {
        logMessages: '',
        log: function (text, logCode) {
            if (this.logMessages === true || this.logMessages.indexOf(logCode) > -1) console.log(text);
        }
    };

    // var code = {
    // 	imageSrc: '/img/scratch-test.png',
    // 	codeWord: 'MEOW!'
    // };

    var code;

    import('./social-codes.json').then(function (json) {
        
        code = (function (codes) {
            //console.log(codes);
            var result;
            for (var i = 0, l = codes.length; i < l; i++) {
                if (compareDate(codes[i].date)) {
                    result = codes[i];
                    break;
                }
            }

            /*** For testing only ***/
            // if(!result) {
            // 	result = {
            // 		imageSrc: 'scratch-kitty.png'
            // 		// codeWord: 'null'
            // 	}
            // }

            if (result) var imgUrl = (/^https?/.test(result.imageSrc)) ? result.imageSrc : '/safehouse-milwaukee/dist/images/scratch-off/' + result.imageSrc;

            return !!result && {
                imageSrc: imgUrl, 
                codeWord: result.codeWord
            };
        })(json.default);

        if (code) {
            $('.scratcher__content').removeClass('noCode');
            $('.codeword').text(code.codeWord);
        }

        var prevWidth = $(window).width();
        $(window).resize(function () {
            if (prevWidth !== $(window).width()) {
                $('.scratcher__content').css('visibility', 'hidden');
                debugbuddy.log($(this).width(), 'resize');
                canvasResize();
            }
            prevWidth = $(window).width();
        });

        canvasResize();
        canvasResize();

        var isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
        if (isMobile) {
            canvas.addEventListener('touchstart', handleMouseDown, false);
            canvas.addEventListener('touchmove', handleMouseMove, false);
            canvas.addEventListener('touchend', handleMouseUp, false);
        } else {
            canvas.addEventListener('mousedown', handleMouseDown, false);
            canvas.addEventListener('mousemove', handleMouseMove, false);
            canvas.addEventListener('mouseup', handleMouseUp, false);

            canvas.addEventListener('mouseenter', function (e) {
                if (e.buttons >= 1 && e.buttons <= 3) handleMouseDown(e);
            }, false);
            canvas.addEventListener('mouseout', handleMouseUp, false);
        }

    });

    // console.log(code);

    function compareDate(date) {

        if (/^\w+ \d{1,2} \d{4} ?- ?[a-zA-Z]+ \d{1,2} \d{4}$/.test(date)) {
            var dateRange = date.split(/ ?- ?/);

            dateRange = dateRange.map(function (a) {
                return new Date(a);
            });

            return (dateRange[0].setHours(hour, 0, 0, 0) <= today) && (dateRange[1].setHours(hour, 0, 0, 0) > today);
        } else {
            if (/^\w+ \d{1,2}$/.test(date)) date = date + ' ' + today.getFullYear();
            var inputDate = new Date(date);

            return (inputDate.setHours(0, 0, 0, 0) === today.setHours(0, 0, 0, 0));
        }

    }

    function getUrlParameter(name) {
        name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
        var regex = new RegExp('[\\?&]' + name + '=([^&#]*)');
        var results = regex.exec(location.search);
        return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    };

    function canvasResize() {
        debugbuddy.log('Running canvasResize', 'func');
        debugbuddy.log('1:' + $('.scratcher__content').outerHeight(), 'resize');

        canvasWidth = Math.min($(window).width() * 0.9, initialWidth);
        canvasHeight = $('.scratcher__content').outerHeight() + 5;

        debugbuddy.log('2:' + $('.scratcher__content').outerHeight(), 'resize');

        $('.scratcher').css({
            'height': canvasHeight,
            'width': canvasWidth
        });

        debugbuddy.log('3:' + $('.scratcher__content').outerHeight(), 'resize');

        canvas.width = canvasWidth;
        canvas.height = canvasHeight;

        loadCanvas();
    }

    function loadCanvas() {
        debugbuddy.log('Running loadCanvas', 'func');
        image.src = code.imageSrc || '/safehouse-milwaukee/dist/images/scratch-off/scratchoff2.jpg';
        // image.src = code.imageSrc || '/img/scratch-test.png';
        image.onload = function () {
            ctx.drawImage(image, 0, 0, canvasWidth - 6, canvasHeight - 6);
            // Show the form when Image is loaded.
            document.querySelectorAll('.scratcher__content')[0].style.visibility = 'visible';
        };
        brush.src = '/safehouse-milwaukee/dist/images/scratch-off/scratch-brush.png';

        // $(canvas).css('opacity', 1);

        // if(canvas.parentNode) canvas.parentNode.removeChild(canvas);
    }

    function distanceBetween(point1, point2) {
        debugbuddy.log('Running distanceBetween', 'func');
        return Math.sqrt(Math.pow(point2.x - point1.x, 2) + Math.pow(point2.y - point1.y, 2));
        // return Math.floor(Math.random()*10);
    }

    function angleBetween(point1, point2) {
        debugbuddy.log('Running angleBetween', 'func');
        return Math.atan2(point2.x - point1.x, point2.y - point1.y);
    }

    // Only test every `stride` pixel. `stride`x faster,
    // but might lead to inaccuracy
    function getFilledInPixels(stride, full) {
        debugbuddy.log('Running getFilledInPixels', 'func');
        if (!stride || stride < 1) {
            stride = 1;
        }

        var x = $('.scratcher--codeword > code').position().left - 5,
            y = $('.scratcher--codeword > code').position().top - 5,
            w = $('.scratcher--codeword > code').width() + 5,
            h = $('.scratcher--codeword > code').height() + 5;

        debugbuddy.log(x + ' ' + y + ' ' + w + ' ' + h, 'pixels');

        // var pixels = ctx.getImageData(0, 0, canvasWidth, canvasHeight),
        var pixels = (code && !full) ? ctx.getImageData(x, y, w, h) : ctx.getImageData(0, 0, canvasWidth, canvasHeight),
            pdata = pixels.data,
            l = pdata.length,
            total = (l / stride),
            count = 0;

        debugbuddy.log(pdata, 'pixels');

        // Iterate over all pixels
        for (var i = count = 0; i < l; i += stride) {
            if (parseInt(pdata[i]) === 0 || (!code) && parseInt(pdata[i]) === 1) {
                count++;
            }
        }

        return Math.round((count / total) * 100);
    }

    function getMouse(e, canvas) {
        // debugbuddy.log('Running getMouse', 'func');
        debugbuddy.log(e, 'events');
        var offsetX = 0,
            offsetY = $('#header').height(),
            mx, my;

        if (canvas.offsetParent !== undefined) {
            do {
                offsetX += canvas.offsetLeft;
                offsetY += canvas.offsetTop;
            } while ((canvas = canvas.offsetParent));
        }

        // console.log(e.pageX, e.pageY);

        mx = (e.pageX || e.touches[0].pageX) - offsetX;
        my = (e.pageY || e.touches[0].pageY) - offsetY;

        return {
            x: mx,
            y: my
        };
    }

    function handlePercentage(filledInPixels) {
        debugbuddy.log('Running handlePercentage', 'func');
        var filledInPixels = filledInPixels || 0;
        debugbuddy.log(filledInPixels + '%', 'fill');
        if (!autoClear && filledInPixels > ((!!code) ? 80 : 90)) {
            // canvas.parentNode.removeChild(canvas);
            codeReveal();
        }
    }

    function codeReveal(speed) {
        var speed = speed || 1000;
        $('.codeword').addClass('declassified');
        $(canvas).animate({
            'opacity': 0
        }, speed, function () {
            $(this).remove();
        });
        $('.btn--scratch-reveal').remove();
    }

    function handleMouseDown(e) {
        if (!drawOverride) {
            debugbuddy.log('Running handleMouseDown', 'func');
            lastPoint = getMouse(e, canvas);
            isDrawing = true;
        }
    }

    function handleMouseMove(e) {

        debugbuddy.log('Running handleMouseMove', 'func');
        if (!isDrawing || (drawOverride && !e.overrider)) {
            return;
        }

        e.preventDefault();

        var currentPoint = getMouse(e, canvas),
            dist = distanceBetween(lastPoint, currentPoint),
            angle = angleBetween(lastPoint, currentPoint),
            x, y;

        for (var i = 0; i < dist; i++) {
            x = lastPoint.x + (Math.sin(angle) * i) - 25;
            y = lastPoint.y + (Math.cos(angle) * i) - 25;
            ctx.globalCompositeOperation = 'destination-out';
            ctx.drawImage(brush, x, y);
        }

        lastPoint = currentPoint;
        handlePercentage(getFilledInPixels(32));
    }

    function handleMouseUp(e) {
        if (!drawOverride) {
            debugbuddy.log('Running handleMouseUp', 'func');
            isDrawing = false;
        }
    }

    $(function () {
        $('.btn--scratch-reveal').click(function () {
            // codeReveal();
            if (!drawOverride) {
                var reverse = false;
                var mouseInt;
                (function drawBrush(originY) {
                    var jitter = function () {
                        return (Math.random() * 4) - 2;
                    };
                    var nextY = jitter() + 20;
                    $('.codeword').addClass('declassified');
                    if (originY > 1200) {
                        codeReveal();
                        // setTimeout(codeReveal, 200);
                        return;
                    }
                    var xMin = $(canvas).offset().left - 20,
                        xMax = $(canvas).offset().left + $(canvas).width() + 20;
                    handleMouseDown({
                        pageX: (reverse) ? xMin : xMax,
                        pageY: originY,
                        preventDefault: function () {
                            // does nothing
                        }
                    });
                    drawOverride = true;
                    autoClear = true;
                    var intCounter = (reverse) ? xMin : xMax;
                    var yCounter = 0;
                    mouseInt = setInterval(function () {
                        var yInt = jitter() + originY + (yCounter / ((xMax - xMin) / 32)) * nextY;
                        handleMouseMove({
                            pageX: intCounter,
                            pageY: yInt,
                            preventDefault: function () {
                                // does nothing
                            },
                            overrider: 1
                        });
                        yCounter += 1 / ((xMax - xMin) / 32);
                        if (reverse) {
                            intCounter -= 32;
                        } else {
                            intCounter += 32;
                        }
                        var condition = (reverse) ? (intCounter <= xMin) : (intCounter >= xMax);
                        if (condition) {
                            clearInterval(mouseInt);
                            isDrawing = false;
                            drawOverride = false;
                            debugbuddy.log(getFilledInPixels(32, true), 'fill');
                            drawBrush(originY + nextY);
                            reverse = !reverse;
                        }
                    }, 10);
                })(600);
            } else {
                drawOverride = false;
                isDrawing = false;
                clearInterval(mouseInt);
                codeReveal(200);
            }
        });
    });
})();

function spoofDate(cvalue) {
    var date = new Date(cvalue).toLocaleDateString();
    //console.log(date);
    location.href = location.origin + location.pathname + '?fakeDate=' + date;
}